import { Image, MediaBox } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import Slider from "dependencies/carousel"

const SliderWrapper = styled(Slider)`
  height: fit-content;
  .slider-frame {
    margin: 0 ${(props) => props.mx || "36px"};
    width: auto !important;
  }
`

const FlexCarousel = ({ children, element }) => {
  const { mx, slides_to_show, ...settings } =
    element.data?.slider_settings || {}

  const sliderSettings = {
    defaultControlsConfig: {
      nextButtonText: (
        <Image
          alt="Next"
          height="25px"
          src={require("images/icons/arrow_bg_lightgray.svg")}
          width="25px"
        />
      ),
      prevButtonText: (
        <Image
          alt="Previous"
          height="25px"
          src={require("images/icons/arrow_bg_lightgray.svg")}
          width="25px"
        />
      ),
    },
    dots: false,
    frameAriaLabel: element.data?.carousel_name,
    slidesToShow: slides_to_show || 3,
    ...settings,
  }

  return (
    <MediaBox
      lessThan="tablet"
      px={2}
      width="100vw"
      {...element.style?.carousel_container_style}
    >
      <SliderWrapper mx={mx} {...sliderSettings}>
        {children}
      </SliderWrapper>
    </MediaBox>
  )
}

FlexCarousel.propTypes = {
  children: PropTypes.node,
  element: PropTypes.object,
}

export default FlexCarousel
